import request from '../utils/request';

// 按一级分类获取二级分类（推荐：用于联动下拉）
export const fetchSubcategoriesByParent = (parentId, params = {}) =>
  request.get(`/admin/subcategory/parent/${parentId}`, { params });

// 分页获取二级分类（可用于管理页/搜索）
export const fetchSubcategoryList = params =>
  request.get('/admin/subcategory/list', { params });


